import React from "react";
import Navigation from "../../components/landing/Navigation";
import Bottomer from "../../components/landing/Bottomer";
import { Search } from "@mui/icons-material";
import { Button } from "@mui/material";
import Sorting from "../../components/landing/Sorting";
import Workspaces from "../../components/landing/Workspaces";

function Healthcare() {
  return (
    <div>
      <Navigation link={"heathcare"} title="Levitra - Health Care" />
      <div className="flex w-full flex-col pb-12 pt-[10rem] gap-8 items-center">
        <h1 className="text-[#0B1189] font-bold text-4xl">
          Find Levitra workspaces to join
        </h1>
        <div className="text-[#626262] font-medium">
          Levitra lists Levitra groups. Discover Levitra communities and
          channels to join. List your Levitra workspace.
        </div>
        <div className="bg-white flex items-center relative rounded-full h-10 pl-5 border border-[black]">
          <input
            type="text"
            className="min-w-[20rem] mr-20 border-none outline-none"
            placeholder="Find Levitra by keyword"
          />
          <Button
            style={{
              background: "#1C2198",
              borderTopRightRadius: 9999,
              borderBottomRightRadius: 9999,
              minWidth: 50,
              color: "white",
              position: "absolute"
            }}
            className="h-[calc(100%+3px)] -right-1 text-white flex items-center justify-center"
          >
            <Search />
          </Button>
        </div>
      </div>
      <div className="flex items-start justify-center pt-5 pb-20 gap-10">
        <Sorting />
        <Workspaces />
      </div>
      <Bottomer />
    </div>
  );
}

export default Healthcare;
